export default "__VITE_ASSET__A$weIBK2__"